<template>
  <div class="main">
    <headert></headert>
    <div class="mainbody">
      <div class="main-header" :class="{ 'shiktop': isTop }">
        <div class="middle">
          <div class="middle-body">
            <img :src="_getLogo($store.state.currentCompany.logo)" class="header-img store-logo">
            <div class="middle-content">
              <span class="store-name extend-click" @click="changeStore">
                {{ $store.state.currentCompany.shortname }}
                <i v-if="this.componylist.length > 1" class="iconfont icon-arrow-down"></i>
              </span>
              <div class="middle-post">{{ $store.state.currentCompany.positionName }}</div>
            </div>
            <router-link @click.native="changeMenus(true)" class="link" tag="span" :to="{ name: 'operate' }" replace>
              操作
            </router-link>
            <router-link v-if="configSettingMenus" @click.native="changeMenus(true)" class="link" tag="span"
              :to="{ name: 'setup' }" replace>
              设置
            </router-link>
          </div>
        </div>
        <div class="menus-wrap">
          <div class="menus" :class="{ 'menushik': menushik }" :style="{ top: showTop + 'px' }">
            <div v-if="routerShow">
              <router-link v-for="(item, index) in filterMenus(false)" :key="index" tag="div" :to="{ name: item.name }"
                event @click.native="goToRouter(item.name, 0)" class="item center">
                <i class="iconfont icon-zhu" :class="item.meta.icon"></i>
                <span class="nav-title">{{ item.meta.title }}</span>
                <span v-if="item.name == 'message' && $store.state.messageCount" class="dota-red text count">{{
                  $store.state.messageCount }}</span>
                <!-- <span v-if="item.name=='pending'&&$store.state.pendingCount" class="dota-red text count">{{$store.state.pendingCount}}</span> -->
                <i class="iconfont icon-iconarrowsright1"></i>
              </router-link>
            </div>
            <div v-if="routerShow" class="shink scroll-bute">
              <div v-if="$route.fullPath.indexOf('operate') >= 0">
                <div class="item center plugins">
                  <i class="iconfont icon-chajian icon-zhu"></i>
                  <span class="nav-title">
                    插件
                  </span>
                </div>
                <router-link class="item center" v-for="(item, index) in filterMenus(true)" :key="index" tag="div"
                  :to="{ name: item.name, params: { id: 0 } }" event @click.native="goToRouter(item.name, 0)">
                  <i class="iconfont plugin" :class="item.meta.icon"></i>
                  <span class="nav-title">{{ item.meta.title }}</span>
                  <i class="iconfont icon-iconarrowsright1"></i>
                </router-link>
              </div>
              <div v-else v-for="zhu in mgrdeptlist" :key="zhu.index">
                <div class="item center plugins">
                  <i class="iconfont icon-huaban icon-zhu"></i>
                  <span class="nav-title">
                    {{ zhu.positionName }}
                  </span>
                </div>
                <router-link class="item center" v-for="(item, index) in filterMenus(true)" :key="index"
                  v-if="item.name == 'member' || (zhu.workflowlist && zhu.workflowlist.length)" tag="div"
                  :to="{ name: item.name, params: { id: zhu.positionId } }" event
                  @click.native="goToRouter(item.name, zhu.positionId)">
                  <i class="iconfont plugin" :class="item.meta.icon"></i>
                  <span class="nav-title">{{ item.meta.title }}</span>
                  <i class="iconfont icon-iconarrowsright1"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrap" :style="{ marginTop: isTop ? '80px' : '' }">
        <div ref="maincontent" class="main-content">
          <keep-alive :include="$store.state.keepArray">
            <router-view v-if="routerShow && $store.state.currentCompany" />
          </keep-alive>
        </div>
      </div>
    </div>
    <footerb></footerb>
    <div v-show="storeShow" @click.stop class="storelist" :class="{ 'anishow': storeShow }"
      :style="{ top: top, left: left }">
      <span class="store-item" @click="changeStore">
        <i class="iconfont icon-clear clear"></i>
      </span>
      <div class="store-scroll scroll-bute">
        <div v-for="item in componylist" :key="item.companyid" class="store-item item-hover" @click="selectStore(item)">
          <img class="store-img" :src="$loadImg(item.logo)">
          <span class="store-name-two chaname">
            <div class="store-name-two chaname" style="flex-direction: column;align-items: flex-start;margin: 0;">
              <label class="fullname" style="margin-bottom: 10px">{{ item.shortname }}</label>
              <div class="store-post" v-if="item.positionName"
                :style="{ background: item.userright == 1 || item.userright == 2 ? '#D16562' : item.userright == 3 ? '#9861CF' : '#ffffff', color: item.userright == 1 || item.userright == 2 || item.userright == 3 ? '#ffffff' : '#3291F8', border: item.userright != 1 && item.userright != 2 && item.userright != 3 ? '1px solid #3291F8' : '' }">
                {{ item.positionName }}</div>
            </div>
            <span v-if="item.taskcnt" class="dota-red count"></span>
          </span>
          <i v-if="item.companyid == $store.state.currentCompany.companyid" class="iconfont icon-duihao duihao"></i>
        </div>
      </div>
    </div>
    <span v-show="storeShow" class="mask"></span>
  </div>
</template>
<script>
import footerb from 'base/footer/footer'
import headert from 'base/header/header'
import { resCode } from 'api/config'
import { notice } from 'common/js/tip'
import { getCompanylist, getCompanyDetail } from 'api/main'
import { operateMenus, getSetupMenus } from '@/router/router'
import { getLogo } from 'api/unifyIcon'
import storage from 'good-storage'
import { hasPrivilege } from 'common/js/permission'
const TOP_HEIGHT = 50
const INIT_TOP = 130
const MENU_TOP = 80
export default {
  components: {
    footerb,
    headert
  },
  data() {
    return {
      isTop: false,
      menushik: false,
      showTop: INIT_TOP,
      storeShow: false,
      componylist: [],
      showMenu: [],
      routerShow: false,
      top: '',
      left: '',
      positionName: null,
      mgrdeptlist: []
    }
  },
  created() {
    this.operateMenus = operateMenus
    this._getCompanylist(1)
    // 当消息条数不存在时跳转到首页
    let messageCount = storage.session.get('message_count')
    if (messageCount == undefined) {
      this.changeMenus(true, true)
    } else {
      this.changeMenus()
    }
    // this.companyDetail = storage.session.get('companyDetail')
  },
  mounted() {
    this.scrollBar()
    this.setMinHeight()
  },
  computed: {
    // 是否配置导航栏 设置 按钮 返回true 则 有设置按钮
    configSettingMenus() {
      // const privilegeList = this.$store.state.currentCompany.privilegeList
      // return privilegeList && privilegeList.length > 0
      // 暂时不通过权限判断，直接放开“设置”入口
      return true
    }
  },
  methods: {
    goToRouter(name, positionId) {
      if (name == 'institution') {
        if (this.$store.state.currentCompany.userright == 5 || this.$store.state.currentCompany.userright == 6) {
          notice('您没有发起制度权限', '')
          return
        }
      } else if (name == 'archive') {
        if (this.$store.state.currentCompany.userright == 5) {
          notice('您没有档案查看权限', '')
          return
        }
      } else if (name == 'leave') {
        if (this.companyDetail.workflowinfo.hasleaveright != 1) {
          notice('你没有发起请假权限', '')
          return
        }
      }
      if (positionId) {
        this.$router.replace({ name: name, params: { id: positionId } })
      } else {
        if (name == 'task') {
          storage.session.remove('deptAuth')
        }
        this.$store.commit('removeKeep', name)
        storage.session.set('scrollbar', 50)
        this.$router.replace({ name: name })
      }
    },
    changeStore($e) {
      if (this.componylist.length === 1) {
        return
      }
      this.storeShow = !this.storeShow
      if (this.storeShow) {
        this.top = ($e.clientY - 10) + 'px'
        this.left = ($e.clientX - 50) + 'px'
        this._getCompanylist(2)
      }
    },
    filterMenus(isplugin) {
      return this.showMenu.filter((item) => {
        if (isplugin) {
          if (item.name == 'institution') {
            if (!(this.$store.state.currentCompany.userright == 5 || this.$store.state.currentCompany.userright == 6)) {
              return item.meta.isplugin == isplugin
            }
          } else if (item.name == 'reimbur') {
            if (this.$store.state.currentCompany.userright != 6) {
              return item.meta.isplugin == isplugin
            }
          } else if (item.name == 'archive') {
            if (this.$store.state.currentCompany.userright != 5) {
              return item.meta.isplugin == isplugin
            }
          } else if (item.name == 'leave') {
            if (this.companyDetail.workflowinfo.hasleaveright == 1) {
              return item.meta.isplugin == isplugin
            }
          } else {
            return item.meta.isplugin == isplugin
          }
        } else {
          if (item.name == 'sixS') {
            if (hasPrivilege('/auth/evaluation/queryEvaluationPosition')) {
              return item.meta.isplugin == false
            } else {
              return item.meta.isplugin == true
            }
          }
          return item.meta.isplugin == isplugin
        }
      })
    },
    _getLogo(url) {
      return getLogo(url)
    },
    changeMenus(isGo = false, message = false) {
      // debugger
      setTimeout(() => {
        if (this.$route.fullPath.indexOf('operate') >= 0 || message) {
          this.showMenu = this.operateMenus
          if (isGo) {
            this.$router.push({ name: 'message' })
          }
        } else {
          this.showMenu = this.updateSetupMenus()
          if (isGo) {
            if (this.showMenu.length) {
              if (this.showMenu[0].meta.isplugin) {
                // if (!this.mgrdeptlist.length) {
                //   return
                // }
                console.log(' this.showMenu', this.showMenu)
                console.log(' this.positionId', this.mgrdeptlist[0].positionId)
                this.$router.push({ name: this.showMenu[0].name, params: { id: this.mgrdeptlist[0].positionId } })
              } else {
                console.log(' this.showMenu123', this.showMenu)
                this.$router.push({ name: this.showMenu[0].name })
              }
            }
          }
        }
      }, 20)
    },
    setMinHeight() {
      const body = document.documentElement || document.body
      const screenHiehgt = body.clientHeight
      this.$refs.maincontent.style.minHeight = (screenHiehgt - 50) + 'px'
    },
    goTop() {
      window.scrollTo(0, 50)
    },
    scrollBar() {
      window.addEventListener('scroll', () => {
        let body = document.documentElement || document.body
        const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
        const clientHeight = body.clientHeight
        const scrollHeight = body.scrollHeight
        // 判断是否到底部
        if ((scrollTop + clientHeight + 80) >= scrollHeight) {
          if (!this.menushik) this.menushik = true
        } else {
          if (this.menushik) this.menushik = false
        }
        // 判断是否是顶部
        if (scrollTop >= TOP_HEIGHT) {
          if (!this.isTop) {
            this.isTop = true
            this.showTop = MENU_TOP
          }
        } else {
          this.showTop = INIT_TOP - scrollTop
          if (this.isTop) this.isTop = false
        }
      })
    },
    selectStore(item) {
      storage.session.clear()
      this.setComPony(item)
      this.changeMenus()
      this.$store.commit('clearKeep')
      notice('机构切换成功', '')
      this.goTop()
      this.$router.replace({ name: 'message' })
      this.changeStore()
    },
    setComPony(item) {
      this.routerShow = false
      this.$store.commit('setCompany', item)
      this._getCompanyDetail(item.companyid)
    },
    updateSetupMenus() {
      const userright = this.$store.state.currentCompany.userright
      let menus = getSetupMenus(userright)
      console.log('menus', menus)
      return menus
    },
    _getCompanylist(first = 0) {
      getCompanylist().then(res => {
        if (res.code === resCode.ERR_OK) {
          this.componylist = res.resdata
          if (first == 1 && !this.$store.state.currentCompany) {
            this.setComPony(this.componylist[0])
          } else if (first == 0 || first == 1) {
            this._getCompanyDetail(this.$store.state.currentCompany.companyid)
          }
        }
      })
    },
    _getCompanyDetail(companyid) {
      getCompanyDetail(companyid).then(res => {
        if (res.code === resCode.ERR_OK) {
          const companyDetail = res.resdata
          if (this.$store.state.currentCompany.userright == 3) {
            // this.mgrdeptlist = [{
            //   positionId: companyDetail.positionId,
            //   positionName: companyDetail.positionName,
            //   workflowlist: companyDetail.workflowlist
            // }]
            this.mgrdeptlist = []
          } else {
            this.mgrdeptlist = []
          }

          this.companyDetail = companyDetail
          storage.session.set('companyDetail', companyDetail)
          this.routerShow = true
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
$menu-height = 60px
$menu-active-color = #325f76
.main
  overflow: hidden
.mainbody
  position: relative
.main-header
  position: relative
  height: 80px
  background-color: $color-background
  &:before
    content: ''
    display: block
    height: 28px
    background-color: #243950
  .middle
    position: absolute
    background-image: url('../assets/dingbudaohao.png')
    background-size: contain
    background-repeat: no-repeat
    width: 1139px
    height: 60px
    opacity: 1
    top: 0
    left: 50%
    transform: translateX(-50%)
    z-index: 1
    .middle-body
      height: 60px
      padding: 0 130px
      color: $text-color-white
      display: flex
      align-items: center
      cursor: pointer
      .middle-content
        display: flex
        flex-direction: column
        .middle-post
          position: relative
          margin: 0 40px 0 20px
          font-size: 14px
          margin-top: 8px;
.store-logo
  vertical-align: middle
.store-name
  position: relative
  margin: 0 40px 0 20px
  font-size: $font-size-medium-x
  min-width: 90px
.link
  display: inline-block
  font-size: $font-size-medium-x
  height: 100%
  display: flex
  align-items: center
  padding: 0 5px
  margin-right: 30px
  border-bottom: 2px solid transparent
.router-link-active.link
  border-color: #fff
.router-link-active.item
  background-color: $menu-active-color
  color: $text-color-white
  & .iconfont
    color: #fff
  &.item:before
    position: absolute
    top: 0
    left: -10px
    content: ''
    width: 10px
    height: $menu-height
    background-color: $menu-active-color
    z-index: 1
  &.item:after
    position: absolute
    left: -10px
    bottom: -10px
    content: ''
    width: 0
    height: 0
    border-width: 10px 10px 10px 0
    border-style: solid
    border-color: transparent #1c4352 transparent transparent
    z-index: 0
.main-wrap
  width: 980px
  margin: 0 auto
  .main-content
    position: relative
    width: 790px
    border-left: 1px solid #cdcdcd
    margin-left: 180px
    background-color: $color-white
    overflow-x: hidden
.menus-wrap
  margin: 0 auto
  width: 960px
.menus
  position: fixed
  top: 130px
  bottom: 0
  width: 190px
  display: flex
  flex-direction: column
  background-color: $color-white
  .shink
    flex: 1
    overflow-y: auto
    border-top: 1px solid $border-color
    background: #fff
    & .item:after
      border-style: none
  .item
    position: relative
    height: $menu-height
    flex-shrink: 0
    text-align: center
    padding: 0 20px
    font-size: $font-size-medium-x
    cursor: pointer
    .nav-title
      overflow: hidden
      white-space: nowrap
      text-overflow: ellipsis
      margin: 0 12px
      flex: 1
      text-align: left
.item:not(.router-link-active):hover
  background-color: $item-hover
.plugins:hover
  background-color: $color-white !important
  cursor: default
.menus.menushik
  bottom: 80px
.main-header.shiktop
  position: fixed
  left: 0
  right: 0
  top: 0
  z-index: 18
.storelist
  position: fixed
  width: 300px
  display: flex
  flex-direction: column
  background-color: $color-white
  color: $color-text
  box-shadow: 0 0 4px 3px rgba(150, 150, 150, 0.3)
  z-index: 20
.store-scroll
  max-height: 420px
  overflow-y: auto
.mask
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(0, 0, 0, 0.3)
  z-index: 18
  cursor: default
.count
  margin: 0 6px
.store-item
  height: 60px
  display: flex
  align-items: center
  justify-content: center
  border-bottom: $border-small
  padding: 0 15px
  flex-shrink: 0
  .chaname
    flex: 1
    display: flex
    align-items: center
    .fullname
      no-wrap()
  .clear
    font-size: $font-size-large-x
    color: $color-gray
.store-img
  width: 40px
  height: 40px
  border: $border-small
  border-radius: 50%
.duihao
  color: $color-red
  font-size: $font-size-large-m
.anishow
  animation: popup-fadein 0.4s
.plugin
  color: $color-gray
.icon-zhu
  color: $color-gray-s
.store-name-two
  position: relative
  margin: 0 20px 0 20px
  font-size: $font-size-medium-x
  min-width: 90px
.store-post
  padding: 3px 4px
  font-size: 14px
  border-radius: 3px
  margin-left: 5px
</style>



// WEBPACK FOOTER //
// src/views/main.vue